<template>
  <v-card
      class="card-border-10"
      outlined>
    <b-table
        table-class="detail-data-table text-20px"
        :fields="getHeaders"
        :items="items">

      <template slot="title" slot-scope="items">
        <v-divider style="margin-top: 0px;"></v-divider>
        <div style="padding-left: 12px;">
          {{ titleText(items.item) }}
        </div>        
      </template>
      
      <template slot="data" slot-scope="items">
        <v-divider style="margin-top: 0px;"></v-divider>
        <div style="padding-left: 8px" class="d-flex align-center">
          <span v-if="dataColon" >:</span>&nbsp;&nbsp;
          <img v-if="items.item.imageUrl" :src="items.item.imageUrl" width="24" height="24" class="me-2" />
          {{ dataText(items.item) }}
        </div>
      </template>

    </b-table>

  </v-card>
</template>

<script>

export default {
  props: {
    loading: {
      type: Boolean,
    },
    headerColon: {
      type: Boolean,
    },
    dataColon: {
      type: Boolean,
      default: false
    },
    simpleHeader: {
      type: String,
    },
    headers: {
      type: Array,
    },
    items: {
      type: Array,
    }
  },
  computed: {
    getHeaders() {
      return this.headers ? this.headers : [
        {key: 'title', label: this.simpleHeader, thStyle: {width: '50%'}},
        {key: 'data', label: ''}
      ]
    }
  },
  methods: {
    titleText(item) {
      return item.title + (this.headerColon ? ":" : "")
    },
    dataText(item) {
      if (!Array.isArray(item.data)) {
        // Truncate department name if title contains "department" or "khoa"
        if (item.title && (item.title.toLowerCase().includes('department') || item.title.toLowerCase().includes('khoa')) && item.data) {
          return this.shortenText(item.data, 50)
        }
        // Truncate email if title contains "email"
        if (item.title && item.title.toLowerCase().includes('email') && item.data) {
          return this.shortenText(item.data, 40)
        }
        // Truncate account name if title contains "account" or "tài khoản"
        if (item.title && (item.title.toLowerCase().includes('account') || item.title.toLowerCase().includes('tài khoản')) && item.data) {
          return this.shortenText(item.data, 35)
        }
        return item.data
      }
      let text = ''
      for (let i = 0; i < item.data.length; i++)
        text += (i === 0 ? '' : " - ") + item.data[i].data
      return text
    },
    shortenText(text, maxLength) {
      return text && text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    }
  }
};
</script>

<style scoped>
.detail-data-table >>> thead th {
  font-weight: bold !important;
  overflow-wrap: anywhere;
}

.detail-data-table >>> tbody td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  padding: 0px;
  padding-bottom: 12px;
}

/* Target the last row's cells */
.detail-data-table >>> tbody tr:last-child td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
  padding: 0px;
}

</style>
